// productServiceTypeList List
const productServiceTypeList = [
    { value: 1, text_en: 'Product', text_bn: 'পণ্য' },
    { value: 2, text_en: 'Service', text_bn: 'সেবা' }
]

const assignTypeList = [
    { value: 1, text_en: 'CIP (Export)', text_bn: 'সিআইপি (রপ্তানি)' },
    { value: 2, text_en: 'National Export Trophy', text_bn: 'জাতীয় রপ্তানি ট্রফি' }
    // { value: 3, text_en: 'All', text_bn: 'সব' }
]

const applicationTypeList = [
    { value: 1, text_en: 'CIP(Export) Application', text_bn: 'সিআইপি(রপ্তানি) আবেদন' },
    { value: 2, text_en: 'National Export Trophy Application', text_bn: 'জাতীয় রপ্তানি ট্রফি আবেদন' }
]

const cipAppTypeList = [
    {
        value: 1,
        text_en: 'Single',
        text_bn: 'একক'
    },
    {
        value: 2,
        text_en: 'Group',
        text_bn: 'গ্রুপ'
    }
]
const latentExporterList = [
    {
        value: 1,
        text_en: 'Yes',
        text_bn: 'হ্যাঁ'
    },
    {
        value: 2,
        text_en: 'No',
        text_bn: 'না'
    },
    {
        value: 3,
        text_en: 'Partial',
        text_bn: 'আংশিক'
    }
]
const orgTypeList = [
    {
        value: 1,
        text_en: 'Private Ltd',
        text_bn: 'প্রাইভেট লিমিটেড'
    },
    {
        value: 2,
        text_en: 'Public Ltd',
        text_bn: 'পাবলিক লিমিটেড'
    },
    {
        value: 3,
        text_en: 'Sole Proprietorship',
        text_bn: 'একক মালিকানা'
    },
    {
      value: 4,
      text_en: 'Partnership Business',
      text_bn: 'অংশীদারি ব্যবসা'
    },
    // {
    //   value: 5,
    //   text_en: 'NGO',
    //   text_bn: 'এনজিও'
    // },
    {
      value: 6,
      text_en: 'Cooperative Societies',
      text_bn: 'সমবায় সমিতি'
    },
    {
      value: 7,
      text_en: 'Statutory Body',
      text_bn: 'বিধিবদ্ধ সংস্থা'
    }
]
const merchandisingTypeList = [
    {
        value: 1,
        text_en: 'Textile / Manufacturing Company',
        text_bn: 'টেক্সটাইল / উৎপাদনকারী প্রতিষ্ঠান'
    },
    {
        value: 2,
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]
const investmentTypeList = [
    {
        value: 1,
        text_en: 'Local',
        text_bn: 'দেশি'
    },
    {
        value: 2,
        text_en: 'Foreign',
        text_bn: 'বিদেশি'
    },
    {
        value: 3,
        text_en: 'Joint Venture',
        text_bn: 'জয়েন্ট ভেঞ্জার'
    }
]
const exportFactorTypeList = [
    {
      value: 1,
      text_en: 'Trading Cum Exporter',
      text_bn: 'ট্রেডিং কাম রপ্তানি কারক'
    },
    {
        value: 2,
        text_en: 'Manufacturing Cum Exporte',
        text_bn: 'উৎপাদনকারী কাম রপ্তানি কারক'
    },
    {
        value: 3,
        text_en: 'Service Exporter',
        text_bn: 'সেবা ধর্মী রপ্তানিকারক '
    }
]

export default {
    productServiceTypeList,
    assignTypeList,
    applicationTypeList,
    cipAppTypeList,
    latentExporterList,
    orgTypeList,
    merchandisingTypeList,
    investmentTypeList,
    exportFactorTypeList
}
